import {EventoOut} from '../../../types/priceResearch'

// Etapas que reabrem a pesquisa (reanálise, retry de cesta, retentativa): o que veio
// antes pertence à rodada anterior e não conta para o progresso atual.
const REABERTURAS = ['REANALISE', 'RETRY', 'RETENTATIVA']

// Passo implícito pelos eventos da rodada corrente. A coleta pode estar andando
// antes de o status chegar à tela; o chamador usa o MAIOR entre este e o do status.
// CONCLUIDO fica de fora: o status final já troca a tela de progresso pelo resultado.
export function stepDosEventos(eventos: EventoOut[] | undefined): number {
    const lista = eventos || []
    let inicio = 0
    lista.forEach((e, i) => {
        // Evento ERRO com etapa de reabertura é falha de item, não reabertura.
        if (e.status !== 'ERRO' && REABERTURAS.includes((e.etapa || '').toUpperCase())) inicio = i + 1
    })
    let maior = 0
    for (const e of lista.slice(inicio)) {
        const etapa = (e.etapa || '').toUpperCase()
        let passo = 0
        if (etapa === 'PARSEANDO') passo = 1
        else if (
            etapa.startsWith('COLETA') ||
            etapa.startsWith('BUSCA') ||
            etapa === 'VERIFICACAO_ATRIBUTOS'
        )
            passo = 2
        else if (etapa === 'EQUALIZACAO' || etapa === 'ESTATISTICA') passo = 3
        if (passo > maior) maior = passo
    }
    return maior
}
